// settings for fab

const fab = () => {
  const fabEl = document.querySelector('.fab');

  if (!fabEl) return;

  const addClass = () => {
    if (window.scrollY > window.innerHeight - 200) {
      fabEl.classList.add('visible');
    } else {
      fabEl.classList.remove('visible');
    }
  };

  addClass();

  document.addEventListener('scroll', () => {
    addClass();
  });

  fabEl.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
};

export default fab;
